import { Modal } from '@frontendmentorio/design-system-v2';

import Content from './Content';

export default function ShareModal({
  emoji,
  modal,
  title,
  solution,
  subtitle,
}) {
  return (
    <Modal className="text-center" modal={modal}>
      <span className="text-4xl">{emoji}</span>

      <Modal.Heading>{title}</Modal.Heading>
      <Content solution={solution} subtitle={subtitle} />
    </Modal>
  );
}
